module.exports = __webpack_public_path__ + "img/culture_item.038d1a36.png";